module.exports = __webpack_public_path__ + "static/media/CretanBull.8d8586e6.jpg";